export const SPLIT_DISTANCES = [500, 1000, 2000, 5000, 10000, 20000, 50000];
export const SIMPLER_THRESHOLD = 0.00002;
export const SIMPLEST_THRESHOLD = 0.0005;

export const GPXDATA_KEYVALUES_MAPPING = {
  distance: {
    distance: { symbol: "distance", label: "track.distance" },
    total: { symbol: "distance", label: "track.distanceTotal" },
  },
  elevation: {
    elevation: { symbol: "elevation", label: "track.elevation" },
    ascent: { symbol: "gpxdata/elevation_up", label: "track.elevationUp" },
    descent: {
      symbol: "gpxdata/elevation_down",
      label: "track.elevationDown",
    },
    lowest: { symbol: "gpxdata/elevation_min", label: "track.elevationMin" },
    highest: { symbol: "gpxdata/elevation_max", label: "track.elevationMax" },
    start: {
      symbol: "gpxdata/elevation_start",
      label: "track.elevationStart",
    },
    end: { symbol: "gpxdata/elevation_end", label: "track.elevationEnd" },
  },
  gradient: {
    minSlope: { symbol: "gradient", label: "track.slopeMin" },
    maxSlope: { symbol: "gradient", label: "track.slopeMax" },
    avgSlope: { symbol: "gradient", label: "track.slopeAvg" },
  },
  speed: {
    speed: { symbol: "speed", label: "track.speed" },
    average: { symbol: "speed", label: "track.speedAvg" },
    peak: { symbol: "gpxdata/speed_max", label: "track.speedMax" },
    averageInMotion: {
      symbol: "speed",
      label: "track.speedAvgInmotion",
    },
  },
  pace: {
    pace: { symbol: "pace", label: "track.pace" },
    average: { symbol: "pace", label: "track.paceAvg" },
    peak: { symbol: "gpxdata/pace_max", label: "track.paceMax" },
    averageInMotion: { symbol: "pace", label: "track.paceAvgInmotion" },
  },
  heartrate: {
    heartrate: {
      symbol: "heartrate",
      label: "track.heartrate",
    },
    average: {
      symbol: "heartrate",
      label: "track.heartrateAvg",
    },
    min: { symbol: "heartrate", label: "track.heartrateMin" },
    max: { symbol: "heartrate", label: "track.heartrateMax" },

    start: { symbol: "heartrate", label: "track.heartrateStart" },
    end: { symbol: "heartrate", label: "track.heartrateEnd" },
  },
  duration: {
    duration: { symbol: "duration", label: "track.timeDuration" },
    total: { symbol: "duration", label: "track.timeDurationTotal" },
    inMotion: {
      symbol: "duration",
      label: "track.timeDurationInmotion",
    },
    stops: { symbol: "stop", label: "track.timeStops" },
  },
  timeDateLong: {
    timeDateStart: { symbol: "time", label: "track.timeStart" },
    timeDateEnd: { symbol: "time", label: "track.timeEnd" },
  },
  time: {
    time: { symbol: "time", label: "track.timeDuration" },
  },
  datetime: {
    datetime: { symbol: "time", label: "track.timeDuration" },
  },
  date: {
    date: { symbol: "time", label: "track.timeDuration" },
  },
  heartRatePercent: {
    heartRatePercent: {
      symbol: "gpxdata/heartrate_max",
      label: "track.heartrateAvgFrommax",
    },
  },
  calories: {
    calories: { symbol: "calories", label: "track.energy" },

    totalCalories: {
      symbol: "calories",
      label: "track.energyTotal",
    },
    activeCalories: {
      symbol: "calories",
      label: "track.energyActive",
    },
  },
  steps: {
    steps: {
      symbol: "steps",
      label: "track.steps",
    },
  },
  temperature: {
    temperature: {
      symbol: "temperature",
      label: "track.temperature",
    },
    average: {
      symbol: "temperature",
      label: "track.temperatureAvg",
    },
    min: { symbol: "temperature", label: "track.temperatureMin" },
    max: { symbol: "temperature", label: "track.temperatureMax" },

    start: { symbol: "temperature", label: "track.temperatureStart" },
    end: { symbol: "temperature", label: "track.temperatureEnd" },
  },
  cadence: {
    cadence: {
      symbol: "cadence",
      label: "track.cadence",
    },
    average: {
      symbol: "cadence",
      label: "track.cadenceAvg",
    },
    max: {
      symbol: "cadence",
      label: "track.cadenceMax",
    },
  },
};

export const _GPXDATA_KEYVALUES_MAPPING = {
  distance: {
    distance: { symbol: "distance", label: "track.distance" },
    total: { symbol: "distance", label: "track.distance" },
  },
  elevation: {
    elevation: { symbol: "elevation", label: "track.elevation" },
    ascent: { symbol: "elevation_up", label: "track.elevationUp" },
    descent: {
      symbol: "elevation_down",
      label: "track.elevationDown",
    },
    lowest: { symbol: "elevation_min", label: "track.elevationMin" },
    highest: { symbol: "elevation_max", label: "track.elevationMax" },
    start: { symbol: "elevation_start", label: "track.elevationStart" },
    end: { symbol: "elevation_end", label: "track.elevationEnd" },
  },
  speed: {
    speed: { symbol: "speed", label: "track.speed" },
    average: { symbol: "speed", label: "track.speed" },
    peak: { symbol: "speed_max", label: "track.speedMax" },
    averageInMotion: {
      symbol: "speed",
      label: "track.speedAvgInmotion",
    },
  },
  pace: {
    pace: { symbol: "pace", label: "track.pace" },
    average: { symbol: "pace", label: "track.pace" },
    peak: { symbol: "pace_max", label: "track.paceMax" },
    averageInMotion: { symbol: "pace", label: "track.paceAvgInmotion" },
  },
  heartrate: {
    heartrate: {
      symbol: "heartrate_max",
      label: "track.heartrate",
    },
    average: {
      symbol: "heartrate_average",
      label: "track.heartrateAvg",
    },
    min: { symbol: "heartrate_min", label: "track.heartrateMin" },
    max: { symbol: "heartrate_max", label: "track.heartrateMax" },
    average: {
      symbol: "heartrate_average",
      label: "track.heartrateAvg",
    },
    start: { symbol: "heartrate_min", label: "track.elevationStart" },
    end: { symbol: "heartrate_max", label: "track.elevationEnd" },
    average: {
      symbol: "heartrate_average",
      label: "track.heartrateAvg",
    },
  },
  duration: {
    duration: { symbol: "duration", label: "track.timeDuration" },
    total: { symbol: "duration", label: "track.timeDuration" },
    inMotion: {
      symbol: "duration",
      label: "track.timeDurationInmotion",
    },
    stops: { symbol: "coffee", label: "track.timeStops" },
  },
  time: {
    time: { symbol: "time_start", label: "track.timeDuration" },
  },
  datetime: {
    datetime: { symbol: "time_start", label: "track.timeDuration" },
  },
  date: {
    date: { symbol: "time_start", label: "track.timeDuration" },
  },
  heartRatePercent: {
    heartRatePercent: {
      symbol: "heartrate",
      label: "track.heartrateAvgFrommax",
    },
  },
  calories: {
    totalCalories: {
      symbol: "calories",
      label: "track.energyTotal",
    },
    activeCalories: {
      symbol: "calories",
      label: "track.energyActive",
    },
  },
  steps: {
    steps: {
      symbol: "steps",
      label: "track.steps",
    },
  },
  cadence: {
    cadence: {
      symbol: "cadence",
      label: "track.cadence",
    },
    average: {
      symbol: "cadence",
      label: "track.cadenceAvg",
    },
    max: {
      symbol: "cadence",
      label: "track.cadenceMax",
    },
  },
};
